import { securePost } from "config/encryption_decryption/get_post_encryptDecrypt";

export type FeedbackFormPayload = {
  feedbackType: string;
  subject: string;
  message: string;
  name: string;
  email: string;
  userId: number | null;
  panelistId: number | string | null;
  sessionId: string | null;
  studyId: string | null;
  currentPage: string;
  userAgent: string;
};

export const submitFeedback = async (payload: FeedbackFormPayload) => {
  return securePost("/api/feedback/submit", payload);
};
